import { useRef } from 'react';
import { useKatex } from '@pm2/react-utils';
import { Link } from '@provider/navigation';
import { Chevron } from '@utils/react';
import { itemCls, linkCls, headingCls, breadcrumbListCls, breadcrumbCls, breadcrumbTextCls, breadcrumbChevronCls, descriptionCls } from './atom.result-item.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function ResultItem({
  id,
  result,
  selected,
  closeSearch
}) {
  const descriptionRef = useRef(null);
  useKatex(descriptionRef);
  return /*#__PURE__*/jsx("li", {
    className: itemCls,
    id: id,
    role: "option",
    "aria-selected": selected,
    "data-path": result.path,
    children: /*#__PURE__*/jsxs(Link, {
      href: result.path,
      className: linkCls,
      onClick: closeSearch,
      tabIndex: -1,
      children: [result.title && /*#__PURE__*/jsx("b", {
        className: headingCls,
        dangerouslySetInnerHTML: {
          __html: result.title
        }
      }), !!result.breadcrumbs?.length && /*#__PURE__*/jsx("nav", {
        "aria-label": "breadcrumbs",
        children: /*#__PURE__*/jsxs("ol", {
          className: breadcrumbListCls,
          children: [(result.breadcrumbs ?? []).map((breadcrumb, index) => /*#__PURE__*/jsxs("li", {
            className: breadcrumbCls,
            children: [/*#__PURE__*/jsx("span", {
              className: breadcrumbTextCls,
              children: breadcrumb.title
            }), (result.title || index !== (result.breadcrumbs?.length ?? 0) - 1) && /*#__PURE__*/jsx("span", {
              "aria-hidden": true,
              className: breadcrumbChevronCls,
              children: /*#__PURE__*/jsx(Chevron, {
                color: "currentColor",
                size: 6,
                lineWidth: 1
              })
            })]
          }, breadcrumb.id)), result.title && /*#__PURE__*/jsx("li", {
            className: breadcrumbCls,
            children: /*#__PURE__*/jsx("span", {
              className: breadcrumbTextCls,
              children: result.title
            })
          })]
        })
      }), result.description && /*#__PURE__*/jsx("p", {
        ref: descriptionRef,
        className: descriptionCls,
        dangerouslySetInnerHTML: {
          __html: result.description
        }
      })]
    })
  });
}

export { ResultItem };
//# sourceMappingURL=atom.result-item.js.map
